import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Home from '../components/HomeGridV2';

import {
  getMyGames,
  filterGames,
  getUpdatedGames,
  getUpdatedMyGames,
  updateUmpAvailableForGame
} from '../actions/gamesActions';
import { getUmpInfo, assignUmpToGame, removeUmp } from '../actions/umpireActions';
import { getSeasonDivisions } from '../actions/divisionsActions';
import { getTeams, getTeamsVolunteering } from '../actions/teamActions';
import { getCoachesTeams } from '../actions/coachActions';
import { clearErrors } from '../actions/errorActions';

const mapDispatchToProps = dispatch => {
  return {
    getMyGames: (season, team, umpire, startDate) => {
      dispatch(getMyGames(season, team, umpire, startDate));
    },
    filterGames: (startDate, endDate, season, division, team, umpire, showAllGames, limitResults) => {
      dispatch(filterGames(startDate, endDate, season, division, team, umpire, showAllGames, limitResults));
    },
    getUmpInfo: memberId => {
      dispatch(getUmpInfo(memberId));
    },
    getSeasonDivisions: (seasonId) => {
      dispatch(getSeasonDivisions(seasonId));
    },
    getTeams: (divisionId, seasonId) => {
      dispatch(getTeams(divisionId, seasonId));
    },
    assignUmpToGame: (umpireId, gameId, plate, updatedGame) => {
      dispatch(assignUmpToGame(umpireId, gameId, plate, updatedGame));
    },
    removeUmp: (umpireId, gameId, plate, updatedGame) => {
      dispatch(removeUmp(umpireId, gameId, plate, updatedGame));
    },
    clearErrors: () => {
      dispatch(clearErrors());
    },
    getCoachesTeams: (memberId, seasonId) => {
      dispatch(getCoachesTeams(memberId, seasonId));
    },
    getTeamsVolunteering: (memberId, seasonId) => {
      dispatch(getTeamsVolunteering(memberId, seasonId));
    },
    getUpdatedMyGames: (season, team, umpire, startDate) => {
      dispatch(getUpdatedMyGames(season, team, umpire, startDate));
    },
    getUpdatedGames: (startDate, numRows, lastStartDate, lastGameId) => {
      dispatch(getUpdatedGames(startDate, numRows, lastStartDate, lastGameId));
    },
    updateUmpAvailableForGame: (gameId, umpAvailable) => {
      dispatch(updateUmpAvailableForGame(gameId, umpAvailable));
    },
  };
};
const mapStateToProps = state => {
  return {
    seasonDivisions: state.divisions.seasonDivisions,
    seasonDivisionsList: state.divisions.seasonDivisionsList,
    fetchingSeasonDivisionsStatus: state.divisions.fetchingSeasonDivisionsStatus,
    fetchingSeasonsStatus: state.seasons.fetchingSeasonsStatus,
    teams: state.teams.teams,
    teamsList: state.teams.teamsList,
    fetchingTeamsStatus: state.teams.fetchingTeamsStatus,
    games: state.games.games,
    filteredGamesList: state.games.filteredGamesList,
    fetchingFilteredGamesStatus: state.games.fetchingFilteredGamesStatus,
    gamesList: state.games.gamesList,
    fetchingGamesStatus: state.games.fetchingGamesStatus,
    myGamesList: state.games.myGamesList,
    fetchingMyGamesStatus: state.games.fetchingMyGamesStatus,
    userType: state.user.userType,
    memberId: state.user.memberId,
    umpires: state.umpires.umpires,
    umpiresList: state.umpires.umpiresList,
    fetchingUmpiresStatus: state.umpires.fetchingStatus,
    error: state.errors.error,
    teamsCoaching: state.user.teamsCoaching,
    fetchingCoachTeamsStatus: state.user.fetchingCoachTeamsStatus,
    teamsVolunteering: state.user.teamsVolunteering,
    fetchingTeamsVolunteering: state.user.teamsVolunteeringStatus,
    updateUmpireStatus: state.games.updateUmpireStatus,
    umpireLevel: state.user.umpireLevel,
    userSeason: state.user.userSeason,
    seasons: state.seasons.seasons,
  };
};

const HomeContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js